import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper";
import testimonialOneData from "./testimonialOneData";

const TestimonialOne = () => {
  return (
    <section className="testimonial-carousel-wrapper  pb-0">
      <div className="container">
        {/* <div className="row">
                    <div className="col-lg-6 offset-lg-3 text-center col-12">
                        <div className="block-contents">
                            <div className="section-title">
                                <span>04. Testimonials</span>
                                <h2>What People say about us</h2>
                            </div>
                        </div>
                    </div>
                </div> */}
        <div className="row section-padding">
          <div className="col-xl-12 col-12">
            <div className="testimonial-carousel-active">
              <Swiper
                navigation={true}
                autoplay={{
                  delay: 3000, // Changed autoplay delay to 3000ms
                  disableOnInteraction: false,
                  pauseOnMouseEnter: false,
                }}
                modules={[Navigation, Autoplay  ]}
                loop
              >
                {testimonialOneData.map((data) => (
                  <SwiperSlide
                    className="single-testimonial-item"
                    key={data.id}
                  >
                    <div className="client-info">
                      <h5>{data.name}</h5>
                      <span>{data.designation}</span>
                    </div>
                    <p className="pb-5">{data.speech}</p>
                    
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialOne;
